import React, { useEffect } from "react";
import {
    Link
} from "react-router-dom";

export default function Guides() {
    useEffect(() => {
        document.title = "Guides";
    }, []);

    return (
        <>
            <div className="container">
                <div className="body">
                    <div className="service">
                        <h1>Chambers & Partners</h1>
                        <nav>
                            <h2>Research</h2>
                            <p><Link to="/research">Research Schedules</Link></p>

                            <h2>Editorial</h2>
                            <p><Link to="/editorial">Editorial History</Link></p>

                            <h2>Ranking History</h2>
                            <p><Link to="/firms">Firms Directory</Link></p>
                            <p><Link to="/lawyers">Lawyers Directory</Link></p>

                            <h2>Archive</h2>
                            <p><a href="/pdf/index.html">Guide PDFs</a></p>
                            <p><Link to="/feedback">Stored Guides</Link></p>
                        </nav>
                    </div>
                    <div className="service">
                        <h1>Legal 500</h1>
                        <nav>
                            <h2>Ranking History</h2>
                            <p><Link to="/l500/firms">Firms Directory</Link></p>
                            <p><Link to="/l500/lawyers">Lawyers Directory</Link></p>
                        </nav>
                    </div>
                </div>
            </div>
        </>
    );
}
